import { Model } from "@tailflow/laravel-orion/lib/model";

export class Attachment extends Model<{}> {
  public $resource(): string {
    return "attachments";
  }
}
